"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenFromGcsUrl = exports.tokenlessGcsUrl = exports.isTokenizedGcsUrl = exports.cleanUrlForInhouse = void 0;
/**
 * @file URL parsing helpers.
 */
const hosts_1 = require("./hosts");
function isTokenizedGcsUrl(url) {
  return !!/^https:\/\/padlet.+\.storage\.googleapis\.com\/.+\?t=.+$/.exec(url);
}
exports.isTokenizedGcsUrl = isTokenizedGcsUrl;
function tryActualUrlFromVivaldiApiUrl(url) {
  const urlObj = new URL(url);
  const isVivaldiHostname = hosts_1.INHOUSE_HOST_LIST.includes(urlObj.hostname);
  if (isVivaldiHostname) return urlObj.searchParams.get('url') || '';
  return '';
}
function tokenlessGcsUrl(url) {
  return url.split('?')[0];
}
exports.tokenlessGcsUrl = tokenlessGcsUrl;
function tokenFromGcsUrl(url) {
  const urlObj = new URL(url);
  return urlObj.searchParams.get('t') || '';
}
exports.tokenFromGcsUrl = tokenFromGcsUrl;
function cleanUrlForInhouse(url) {
  if (isTokenizedGcsUrl(url)) return tokenlessGcsUrl(url);
  const possiblyRealUrl = tryActualUrlFromVivaldiApiUrl(url);
  if (possiblyRealUrl) return possiblyRealUrl;
  return url;
}
exports.cleanUrlForInhouse = cleanUrlForInhouse;